export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/worker/certificate_level',
      method: 'GET'
    }]
  }
}